import React from "react";
import { Link } from "react-router-dom";

const AboutSection = () => {
  return (
    <section className="about-section pb-2">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 py-lg-0 py-3 d-flex justify-content-lg-start justify-content-center">
            <div
              className="about-image"
              data-sal="slide-up"
              data-sal-duration="1000"
              data-sal-delay="100"
            >
              <img src="/assets/img/dr-s-rajkumar-2.webp" alt="about" />
            </div>
          </div>
          <div className="col-lg-6 py-lg-0 py-3 d-flex align-items-center justify-content-center">
            <div
              className="about-content"
              data-sal="slide-up"
              data-sal-duration="1000"
              data-sal-delay="200"
            >
              <p>Dr. J S Rajkumar, fondly known as Dr. JSR, was a studious and an enthusiastic medical student, who won 32 Gold medals and the Johnston best outgoing student award at the Madras Medical College . He received four medical specializations from the Royal College of Surgeons in the United Kingdom. </p>
              <Link to="/doctor/js-raj-kumar" className="about-btn">
                Read More
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;